<template>
  <div class="tiger-main" :style="mainStyle">
    <keep-alive>
      <router-view/>
    </keep-alive>
    <tiger-mail :position="position"/>
    <el-divider/>
  </div>
</template>

<script>
import TigerMail from "@/components/TigerMail";
import {resize} from "@/utils/resize";

export default {
  name: "TigerMain",

  components: {TigerMail},

  mixins: [resize],

  computed: {
    position() {
      return this.$route.path === '/contact' ? 'center' : 'left';
    },

    mainStyle() {
      return {
        paddingTop: this.$route.path === '/about' ? 0 : this.calcToPx(.833, 48, 96)
      };
    }
  }
}
</script>

<style lang="scss" scoped>
.tiger-main {
  width: 100vw;
  min-width: 960px;
  background-color: $col-primary-black;

  .el-divider {
    opacity: .15;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/TigerMain.vue